import { Injectable } from '@angular/core';
import { ActivatedRoute } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class RedirectService {
    constructor(private route: ActivatedRoute) {
    }

    redirect(url: string) {
        // create a /auth request for code authorization flow
        this.route.queryParams.subscribe(async params => {
            try {
                let tempCred = params['tempCred'];

                let tenant = params['tenanthost'];
                if(tenant){
                  window.location.href = url + '?tenanthost='+tenant+'&tempCred=' + tempCred;
                }else{
                  window.location.href = url + '?tempCred=' + tempCred;
                }

                //    In case something does not work redirect to product
            } catch (e) {
                window.location.href = url;
            }
        })
    }
}
